import { recuperarSugestoesStakeholdersComFoto } from '../busca/recuperarSugestoesBusca'
import { mapearParaStakeholders } from './stakeholderUtil'

export async function recuperarStakeholdersResumidosPorTexto(textoLivre: string, limite: number) {
  const listaStakeholders = await recuperarSugestoesStakeholdersComFoto(textoLivre, limite)
  return mapearParaStakeholders(listaStakeholders)
}

